import { Injectable } from '@angular/core';
import {AuthService} from "../auth.service";
import {HttpClient} from "@angular/common/http";

@Injectable({
    providedIn: 'root'
})
export class EvidencesService extends AuthService {

    private url = '';

    constructor(
        auth: AuthService,
        http: HttpClient,
    ) {
        super(http);
        this.url = this.endpoint + '/web-audit'
    }


    getEvidences() {
        return this.http.post(
            this.url + '/evidences', {}, {headers: this.getHeaders()}
        )
    }

}
